import { SchedulingFieldsFragment } from 'api/graphql-types';
import { Typography } from 'components/typography';
import { sanitizeAndParseHtml } from 'utils/rich-text-renderer/sanitize-and-parse';

import styles from './scheduling-module.module.scss';

interface ISchedulingModuleProps {
	module: SchedulingFieldsFragment;
}

const SchedulingModule = (props: ISchedulingModuleProps): React.JSX.Element => {
	const backgroundColor = props.module?.defaultModuleOptions?.backgroundColor;
	const background = backgroundColor === 'white' ? styles.grey : backgroundColor === 'grey' && styles.white;

	return (
		<>
			{props.module?.title?.value && (
				<Typography tag={props.module.title?.type || 'h2'} variant="h2" className={styles.title}>
					{props.module.title.value}
				</Typography>
			)}

			<table className={`${styles.schedulingTable} ${background}`}>
				<thead>
					<tr>
						<th>{props.module.firstColumnTitle}</th>
						{props.module?.secondColumnTitle && <th>{props.module.secondColumnTitle}</th>}
					</tr>
				</thead>
				<tbody>
					{props.module.firstColumnRows?.map(
						(row, i) =>
							row && (
								<tr key={`row ${i}`}>
									{row?.bodyText && <td>{sanitizeAndParseHtml(row.bodyText)}</td>}
									{props.module?.secondColumnRows && props.module?.secondColumnRows.length > 0 && (
										<td>{sanitizeAndParseHtml(props.module?.secondColumnRows[i]?.bodyText as string)}</td>
									)}
								</tr>
							)
					)}
				</tbody>
			</table>
		</>
	);
};

export default SchedulingModule;
